import { render, staticRenderFns } from "./noticeControl.vue?vue&type=template&id=6d396df8&scoped=true&"
import script from "./noticeControl.vue?vue&type=script&lang=js&"
export * from "./noticeControl.vue?vue&type=script&lang=js&"
import style0 from "./noticeControl.vue?vue&type=style&index=0&id=6d396df8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d396df8",
  null
  
)

export default component.exports